import axios from "axios";
import { SERVER_URL } from "../const";


// API calls
// Login 
export async function loginService(userDetails) {
  return await axios.post(SERVER_URL + "/login", userDetails);
}

export const sendOtpService = async (email, method) => {
  return await axios.post(`${SERVER_URL}/send-otp?email=${email}&method=${method}`);
};

export const verifyOtpService = async (payload) => {
  return await axios.post(SERVER_URL + "/verify-otp", payload);
};


export const AddAdminUserService = async (requestData) => {
  const token = localStorage.getItem('token');
  try {
    // Make a POST request to the API endpoint using Axios
    const response = await axios.post(SERVER_URL + "/add-admin", requestData,
      { headers: { 'Authorization': 'Bearer ' + token } });

    // Handle the response as needed
    if (response.status !== 200) {
      throw new Error(response.msg)
    }

    return response.data; // You can modify this based on your response structure
  } catch (error) {
    // Handle errors
    console.error('Error:', error);
    throw error; // Rethrow the error if needed
  }
};

export const AddSuperAdminService = async (requestData) => {
  const token = localStorage.getItem('token');
  try {
    const response = await axios.post(SERVER_URL + "/add-superadmin", requestData,
      { headers: { 'Authorization': 'Bearer ' + token } });

    if (response.status !== 200) {
      throw new Error(response.msg)
    }

    return response.data;
  } catch (error) {
    // Handle errors
    console.error('Error:', error);
    throw error;
  }
};

export const UpdateUserPageAccessMapping = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    // Make a POST request to the API endpoint using Axios
    const response = await axios.post(SERVER_URL + "/user/rbac/update", payload,
      { headers: { 'Authorization': 'Bearer ' + token } });

    // Handle the response as needed

    return response.data; // You can modify this based on your response structure
  } catch (error) {
    // Handle errors
    console.error('Error:', error);
    // throw error; // Rethrow the error if needed
  }
}

export const resetUserPasswordService = async (id, newPassword, token) => {
  try {
    const response = await axios.put(SERVER_URL + `/user/reset-password/${id}`,
      { new_password: newPassword },
      {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
      });

    if (response.status === 200) {
      return response.data;
    } else {

      throw new Error(response.statusText);
    }
  } catch (error) {
    console.error('Error resetting password:', error);
    throw error;
  }
};

// List users
export async function getUsers(token, skip) {

  return axios.get(SERVER_URL + "/users?skip=" + skip, { headers: { 'Authorization': 'Bearer ' + token } })

}
// Get logged in user details
export async function userAccount(token) {
  return await axios.get(SERVER_URL + "/user-account", { headers: { 'Authorization': 'Bearer ' + token } });
}

// Get user rbac details
export async function userRbac(token) {
  return await axios.get(SERVER_URL + "/user/rbac", { headers: { 'Authorization': 'Bearer ' + token } });
}

// Get cip pages
export async function getCipPagesService(token) {
  return await axios.get(SERVER_URL + "/cip-pages", { headers: { 'Authorization': 'Bearer ' + token } });
}

// Get user role
export async function userRole(token) {

  return await axios.get(SERVER_URL + "/user-role", { headers: { 'Authorization': 'Bearer ' + token } });

}
// Change password
export async function changePassword(token, changePassword) {
  return await axios.post(SERVER_URL + "/users/change-password", { password: changePassword }, { headers: { 'Authorization': 'Bearer ' + token } });

}


// Update user details
export async function updateUser(token, updateUserDetails) {
  return await axios.put(SERVER_URL + "/update-user", updateUserDetails, { headers: { 'Authorization': 'Bearer ' + token } });

}

// Delete user
export async function deleteUser(token, delete_user_schema) {
  return await axios.delete(SERVER_URL + "/delete-user", { headers: { 'Authorization': 'Bearer ' + token }, data: delete_user_schema });

}


// Reset user password
export async function resetPassword(token, updateUserDetails) {
  return await axios.put(SERVER_URL + "/reset-password", updateUserDetails, { headers: { 'Authorization': 'Bearer ' + token } });

}

// Get document links
export async function getDocLinks(iec_no) {
  const token = localStorage.getItem('token')
  return await axios.get(`${SERVER_URL}/document-links/${iec_no}`, { headers: { 'Authorization': 'Bearer ' + token } });
}

// send consulation request via email
export async function sendConsultationRequest(consultationForm) {
  const token = localStorage.getItem('token')
  return await axios.post(SERVER_URL + "/consultation", consultationForm, { headers: { 'Authorization': 'Bearer ' + token } });
}

export const getAllGroupsService = async (token) => {
  try {
    const response = await axios.get(SERVER_URL + "/getGroups", {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching groups:', error);
    throw error;
  }
};

export const createGroupService = async (token, groupName, memberIecs = []) => {
  try {
    const response = await axios.post(SERVER_URL + "/addGroup", { name: groupName, member_iecs: memberIecs }, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating group:', error);
    throw error;
  }
};

export const getGroupMembersService = async (token, group_id) => {
  try {
    const response = await axios.get(SERVER_URL + `/getGroupMembers/${group_id}`, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching group members:', error);
    throw error;
  }
};

export const updateGroupService = async (token, groupData) => {
  try {
    const response = await axios.put(SERVER_URL + "/updateGroup", groupData, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating group:', error);
    throw error;
  }
};

export const deleteGroupService = async (token, group_id) => {
  try {
    const response = await axios.delete(`${SERVER_URL}/deleteGroup/${group_id}`, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting group:', error);
    throw error;
  }
};
export const searchAdminByIecService = async (token, iec_no) => {
  try {
    const response = await axios.get(`${SERVER_URL}/search-admin/${iec_no}`, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    return response.data;
  } catch (error) {
    console.error('Error searching admin by IEC:', error);
    throw error;
  }
};

export const claimAdminToGroupService = async (token, payload) => {
  try {
    const response = await axios.post(`${SERVER_URL}/claim-admin`, payload, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    return response.data;
  } catch (error) {
    console.error('Error claiming admin to group:', error);
    throw error;
  }
};

// --- SSO Services ---

export const createSsoConfigService = async (token, data) => {
  return await axios.post(`${SERVER_URL}/sso-config`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const updateSsoConfigService = async (token, configId, data) => {
  return await axios.put(`${SERVER_URL}/sso-config/${configId}`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const getSsoConfigsService = async (token) => {
  return await axios.get(`${SERVER_URL}/sso-config`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const checkSsoService = async (email) => {
  return await axios.get(`${SERVER_URL}/auth/check-sso?email=${encodeURIComponent(email)}`);
};

export const ssoLoginService = async (email) => {
  return await axios.get(`${SERVER_URL}/auth/sso/login?email=${encodeURIComponent(email)}`);
};
